import Icon from '../components/Icon.vue'

Icon.register({"ban":{"width":1536,"height":1792,"paths":[{"d":"M1312 893q0-161-87-295l-754 753q137 89 297 89 111 0 211.5-43.5t173.5-116.5 116-174.5 43-212.5zM313 1192l755-754q-135-91-300-91-148 0-273 73t-198 199-73 274q0 162 89 299zM1536 893q0 157-61 300t-163.5 246-245 164-298.5 61-298.5-61-245-164-163.5-246-61-300 61-299.5 163.5-245.5 245-164 298.5-61 298.5 61 245 164 163.5 245.5 61 299.5z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/ban.js
// module id = 1280
// module chunks = 0